import { cn } from '@/shared/utils/cn';
import React from 'react';

export interface ListAlphabeticGroup {
  letter: string;
  items: string[];
}

export interface ListAlphabeticProps {
  groups: ListAlphabeticGroup[];
  selectedItem?: string;
  onItemClick?: (item: string, groupIndex: number, itemIndex: number) => void;
  className?: string;
}

export const ListAlphabetic: React.FC<ListAlphabeticProps> = ({
  groups,
  selectedItem,
  onItemClick,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-flex ui-min-w-[208px] ui-flex-col ui-gap-8',
        className,
      )}
    >
      {groups.map((group, groupIndex) => (
        <div key={group.letter}>
          {/* Letter Header */}
          <div className="ui-mb-8 ui-text-body-xs-regular ui-font-body-xs-semibold ui-text-secondary">
            {group.letter}
          </div>

          {/* Items */}
          <div className="ui-flex ui-flex-col ui-gap-8">
            {group.items.map((item, itemIndex) => {
              const isSelected = selectedItem === item;
              return (
                <div
                  key={`${group.letter}-${itemIndex}`}
                  onClick={() => onItemClick?.(item, groupIndex, itemIndex)}
                  className={cn(
                    'ui-cursor-pointer ui-rounded-control-sm ui-px-8 ui-py-6 ui-text-body-sm-regular ui-font-body-sm-medium ui-transition-all',
                    {
                      // Selected: azul oscuro
                      'ui-bg-fill-brand ui-text-on-color': isSelected,
                      // Default text
                      'ui-text-primary': !isSelected,
                      // Hover: gris claro (solo cuando no está seleccionado)
                      'hover:ui-bg-fill-hover': !isSelected,
                    },
                  )}
                >
                  {item}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
